module.exports = __webpack_public_path__ + "img/phone.c68a24fc.svg";